import React from 'react';
import { 
  Box, 
  Flex, 
  HStack, 
  IconButton, 
  Button, 
  Menu, 
  MenuButton, 
  MenuList, 
  MenuItem, 
  MenuDivider, 
  useDisclosure, 
  useColorModeValue, 
  Stack, 
  Text, 
  Container,
  Badge
} from '@chakra-ui/react';
import { HamburgerIcon, CloseIcon, ChevronDownIcon } from '@chakra-ui/icons';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { useWallet } from '../context/WalletContext';

// Define the navigation items
const navItems = [
  { name: 'Home', path: '/' },
  { name: 'BlindBox', path: '/blindbox' },
  { name: 'Liquidity', path: '/liquidity' },
  { name: 'Dashboard', path: '/dashboard' }
];

const Navbar: React.FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { walletAddress, userBalance, connectWallet, disconnectWallet, addBalance } = useWallet();
  const location = useLocation();

  // Handle wallet connection
  const handleConnect = () => {
    connectWallet();
  };

  // Handle wallet disconnection
  const handleDisconnect = () => {
    disconnectWallet();
  };

  // Add demo SOL to wallet
  const handleAddSol = async () => {
    await addBalance(10);
  };

  return (
    <Box 
      bg={useColorModeValue('white', 'gray.900')} 
      px={4} 
      boxShadow="sm"
      position="sticky"
      top={0}
      zIndex={999}
    >
      <Container maxW="container.xl">
        <Flex h={16} alignItems={'center'} justifyContent={'space-between'}>
          <IconButton
            size={'md'}
            icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
            aria-label={'Open Menu'}
            display={{ md: 'none' }}
            onClick={isOpen ? onClose : onOpen}
          />
          <HStack spacing={8} alignItems={'center'}>
            <Box fontWeight="bold" fontSize="xl" color="brand.500">BlindBox</Box>
            <HStack as={'nav'} spacing={4} display={{ base: 'none', md: 'flex' }}>
              {navItems.map((navItem) => (
                <RouterLink key={navItem.path} to={navItem.path}>
                  <Button
                    variant={location.pathname === navItem.path ? 'solid' : 'ghost'}
                    colorScheme={location.pathname === navItem.path ? 'brand' : undefined}
                    size="sm"
                  >
                    {navItem.name}
                  </Button>
                </RouterLink>
              ))}
            </HStack>
          </HStack>
          <Flex alignItems={'center'}>
            {walletAddress ? (
              <HStack spacing={3}>
                <Badge colorScheme="green" variant="solid" px={2} py={1} borderRadius="md">
                  {userBalance.toFixed(2)} SOL
                </Badge>
                <Menu>
                  <MenuButton
                    as={Button}
                    size="sm"
                    variant="outline"
                    colorScheme="brand"
                    rightIcon={<ChevronDownIcon />}
                  >
                    {walletAddress.substring(0, 6)}...{walletAddress.substring(walletAddress.length - 4)}
                  </MenuButton>
                  <MenuList>
                    <MenuItem onClick={handleAddSol}>Add 10 SOL (Demo)</MenuItem>
                    <MenuDivider />
                    <MenuItem onClick={handleDisconnect}>Disconnect Wallet</MenuItem>
                  </MenuList>
                </Menu>
              </HStack>
            ) : (
              <Button 
                colorScheme="brand" 
                size="sm" 
                onClick={handleConnect}
              >
                Connect Wallet
              </Button>
            )}
          </Flex>
        </Flex>

        {isOpen ? (
          <Box pb={4} display={{ md: 'none' }}>
            <Stack as={'nav'} spacing={4}>
              {navItems.map((navItem) => (
                <RouterLink key={navItem.path} to={navItem.path} onClick={onClose}>
                  <Button
                    w="full"
                    variant={location.pathname === navItem.path ? 'solid' : 'ghost'}
                    colorScheme={location.pathname === navItem.path ? 'brand' : undefined}
                    size="sm"
                  >
                    {navItem.name}
                  </Button>
                </RouterLink>
              ))}
            </Stack>
          </Box>
        ) : null}
      </Container>
    </Box>
  );
};

export default Navbar; 